import { DialogContent, DialogTitle, Stack } from '@mui/material';
import { PromptGroupsList } from '../PromptGroupsList';
import { usePromptGroups } from '../usePromptGroups';
import { useSelector } from 'react-redux';
import { selectPromptGroups } from '../../../../reducers/promptLibraryReducer';
import { CloseButton } from './CloseButton';
import { Button, Typography } from '@sweep-io/sweep-design';

interface PromptGroupsViewProps {
  onClose: () => void;
}

export const PromptGroupsView = ({ onClose }: PromptGroupsViewProps) => {
  const { selectGroup, addEmptyPromptGroup } = usePromptGroups();
  const promptGroups = useSelector(selectPromptGroups);
  const hasNewPromptGroupCard = !!promptGroups?.some((group) => group.id === '');

  return (
    <>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h1">Prompts library</Typography>
        <Stack direction="row" spacing={1} alignItems="center">
          <Button
            variant="secondary"
            startIconName="Plus"
            disabled={hasNewPromptGroupCard}
            onClick={() => addEmptyPromptGroup()}
          >
            New category
          </Button>

          <CloseButton onClose={onClose} />
        </Stack>
      </DialogTitle>
      <DialogContent sx={{ mt: 2, pb: 3 }}>
        <PromptGroupsList promptGroups={promptGroups ?? []} onPromptCardClick={selectGroup} />
      </DialogContent>
    </>
  );
};
